import type { Socket } from 'socket.io-client'
import { createSocket } from '@/lib/player-socket'

let slideSocket: Socket | null = null

export function getSlideSocket(): Socket {
	if (!slideSocket) {
		slideSocket = createSocket({
			namespace: '/slide-game',
		})
	}

	return slideSocket
}

export function disconnectSlideSocket(): void {
	if (!slideSocket) {
		return
	}

	slideSocket.removeAllListeners()
	slideSocket.disconnect()
	slideSocket = null
}
